<div [ngClass]="{'small': !!media}" class="play-pause">
  <button (click)="play()" *ngIf="!isPlaying" class="play-pause-icon simple paused">
    <img alt="play icon" class="action" src="/assets/icons/play-icon.svg"/>
  </button>
  <button (click)="pause()" *ngIf="isPlaying" class="play-pause-icon simple playing">
    <img alt="pause icon" class="action" src="/assets/icons/pause-icon.svg"/>
  </button>
</div>
